import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const LMS: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const levelTestItems = [
    { title: '유.초등 레벨테스트', path: '/lms/level-test#elementary' },
    { title: '초4+ 레벨테스트', path: '/lms/level-test#grade4plus' },
    { title: '중.고등 ELTIS 테스트', path: '/lms/level-test#eltis' },
  ];

  const learningHubItems = [
    { title: 'English Open Library 잉글리시 오픈 라이브러리', path: '/lms/learning-hub#english-open-library' },
    { title: 'Discovery 디스커버리', path: '/lms/learning-hub#discovery' },
    { title: 'Elevate 엘리베이트', path: '/lms/learning-hub#elevate' },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      {/* Page Header */}
      <div className="relative text-white py-12 sm:py-16 md:py-20 lg:py-24 mt-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=1920&h=600&fit=crop&q=80"
            alt="LMS"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/50"></div>
        </div>

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <p className="text-gray-200 mb-2 sm:mb-3 text-xs sm:text-sm font-medium tracking-wider">Learning Management System</p>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-3 sm:mb-4">LMS</h1>
          <div className="w-16 sm:w-20 h-1 bg-white/70 mb-4"></div>
          <p className="text-gray-200 text-sm sm:text-base">평가에서 학습까지 연결되는<br />글로벌 온라인 학습 플랫폼</p>
        </div>
      </div>

      {/* Content Section */}
      <div className="flex-1 py-8 sm:py-10 md:py-12 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">

          {/* 소개 문구 */}
          <div className="bg-white rounded-lg shadow-sm p-6 sm:p-8 mb-8">
            <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
              Reading Assessment Hub & Learning Hub 개인별 읽기 수준에 따라 평가와 학습이 자동으로 연계됩니다.
            </p>
          </div>

          {/* LMS 메뉴 카드 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* 레벨테스트 카드 */}
            <div className="bg-white rounded-lg shadow-sm overflow-hidden">
              <Link
                to="/lms/level-test"
                className="block group"
              >
                <div className="aspect-video relative overflow-hidden">
                  <img
                    src="https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=800&h=450&fit=crop&q=80"
                    alt="레벨테스트"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black/40 group-hover:bg-black/30 transition-colors"></div>
                </div>
                <div className="p-6 pb-4">
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-green-600 transition-colors">레벨테스트</h3>
                  <p className="text-gray-600 text-sm">
                    학습자의 현재 영어 실력을 정확히 진단하여 적합한 수준의 교육 프로그램을 추천해 드립니다.
                  </p>
                </div>
              </Link>
              {/* 바로가기 항목들 */}
              <div className="px-6 pb-6">
                <div className="border-t border-gray-100 pt-4">
                  <ul className="space-y-2">
                    {levelTestItems.map((item) => (
                      <li key={item.path}>
                        <Link
                          to={item.path}
                          className="flex items-center text-sm text-gray-600 hover:text-green-600 transition-colors"
                        >
                          <svg className="w-4 h-4 mr-2 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                          </svg>
                          {item.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            {/* 학습 허브 카드 */}
            <div className="bg-white rounded-lg shadow-sm overflow-hidden">
              <Link
                to="/lms/learning-hub"
                className="block group"
              >
                <div className="aspect-video relative overflow-hidden">
                  <img
                    src="https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=800&h=450&fit=crop&q=80"
                    alt="학습 허브"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 bg-black/40 group-hover:bg-black/30 transition-colors"></div>
                </div>
                <div className="p-6 pb-4">
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors">학습 허브</h3>
                  <p className="text-gray-600 text-sm">
                    Discovery와 Elevate 플랫폼을 통해 개인별 수준에 맞는 학습 콘텐츠를 제공합니다.
                  </p>
                </div>
              </Link>
              {/* 바로가기 항목들 */}
              <div className="px-6 pb-6">
                <div className="border-t border-gray-100 pt-4">
                  <ul className="space-y-2">
                    {learningHubItems.map((item) => (
                      <li key={item.path}>
                        <Link
                          to={item.path}
                          className="flex items-center text-sm text-gray-600 hover:text-blue-600 transition-colors"
                        >
                          <svg className="w-4 h-4 mr-2 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                          </svg>
                          {item.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <Footer />
    </div>
  );
};

export default LMS;
